import React from "react";
import cx from "classnames";
import styles from "./FrequencyOptionCard.module.scss";
import { CurrentPlanBadge } from "../Badge";

const FrequencyOptionCard = ({
    className = "",
    current = false,
    active,
    title,
    ...props
}) => {
    const showEvery = !title.startsWith("Every");

    return (
        <div
            className={cx(
                "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3",
                styles.card,
                active && styles.activeCard,
                className,
            )}
            {...props}
        >
            <div className={styles.body}>
                {(showEvery || current) && (
                    <div className={styles.everyRow}>
                        {showEvery && <p className={styles.every}>Every</p>}
                        {current && <CurrentPlanBadge />}
                    </div>
                )}
                <p className={cx(styles.title)}>{title}</p>
            </div>
        </div>
    );
};

export default FrequencyOptionCard;
